module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/printfooter/printfooter.component.css
// module id = ./src/app/printfooter/printfooter.component.css
// module chunks = main